// extracted by mini-css-extract-plugin
module.exports = {"input":"Select_input__l5Rsp"};